import { reducer as earlyBirdOfferList } from "app/pages/EarlyBirdOfferList/modules/EarlyBirdOfferList";

export const reducers = {
    earlyBirdOfferList,
};